import React from "react"

type Args = {
  content: Record<string, unknown>
}

export const JsonContentMarkup = ({ content }: Args) => {
  return (
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        ...content,
      })}
    </script>
  )
}
